export default [
    {
        path: '/',
        component: require('../components/the-layout-www').default,
        children: [
            {
                name: 'www.home.index',
                path: '',
                component: require('../views/www/home/index').default
            },
            {
                name: 'www.blog.index',
                path: '/blog',
                component: require('../views/www/blog/index').default
            },
            {
                name: 'www.blog.show',
                path: '/blog/:post',
                component: require('../views/www/blog/show').default
            },
            {
                path: '/demo',
                name: 'www.demos.index',
                component: require('../views/www/demos/index').default
            },
            {
                path: '/contact',
                name: 'www.contact.index',
                component: require('../views/www/contact/index').default,
                meta: {
                    'the-layout-www': {
                        bg: 'hero-background-blue-bg'
                    }
                }
            },
            {
                path: '/reviews',
                name: 'www.reviews.index',
                component: require('../views/www/reviews/index').default
            },
            {
                path: '/for-landlords',
                name: 'www.landlords.index',
                component: require('../views/www/landlords/index').default
            },
            {
                path: '/for-landlords/rent-collection',
                name: 'www.landlords.rent-collection.index',
                component: require('../views/www/landlords/rent-collection/index').default
            },
            {
                path: '/for-landlords/property-listings',
                name: 'www.landlords.listings.index',
                component: require('../views/www/landlords/listings/index').default
            },
            {
                path: '/for-landlords/organisation',
                name: 'www.landlords.organisation.index',
                component: require('../views/www/landlords/organisation/index').default
            },
            {
                path: '/for-landlords/switch',
                name: 'www.landlords.switch.index',
                component: require('../views/www/landlords/switch/index').default,
                meta: {
                    'the-layout-www': {
                        bg: 'hero-background-white'
                    }
                }
            },
            {
                path: '/for-tenants',
                name: 'www.tenants.index',
                component: require('../views/www/tenants/index').default
            },
            {
                path: '/for-tenants/pay-rent-by-card-online',
                name: 'www.tenants.payments.index',
                component: require('../views/www/tenants/payments/index').default
            },
            {
                path: '/for-tenants/find-your-next-home',
                name: 'www.tenants.listings.index',
                component: require('../views/www/tenants/listings/index').default
            },
            {
                path: '/for-tenants/organisation',
                name: 'www.tenants.organisation.index',
                component: require('../views/www/tenants/organisation/index').default
            },
            {
                name: 'www.pricing.index',
                path: '/pricing',
                component: require('../views/www/pricing/index').default
            },
            {
                name: 'www.policies.cookies.index',
                path: '/policies/cookies',
                component: require('../views/www/policies/cookies/index').default
            },
            {
                name: 'www.policies.privacy.index',
                path: '/policies/privacy',
                component: require('../views/www/policies/privacy/index').default
            },
            {
                name: 'www.policies.terms.index',
                path: '/policies/terms',
                component: require('../views/www/policies/terms/index').default
            },
            {
                path: 'listings',
                name: 'listings.index',
                component: require('../views/listings/index').default
            },
            {
                path: 'listings/regions/:category/:subcategory',
                name: 'listings.regions.index',
                component: require('../views/listings/regions/index').default
            },
            {
                path: 'listings/in/:location',
                name: 'listings.in.index',
                component: require('../views/listings/in/index').default
            },
            {
                path: 'listings/:listing',
                name: 'listings.show',
                component: require('../views/listings/show').default
            },
            {
                path: 'listings/:listing/messages/new',
                name: 'listings.messages.create',
                component: require('../views/listings/messages/create').default
            }
        ]
    },
    {
        path: '/listings/:listing/messages/:message/send',
        component: require('../components/the-layout-card').default,
        children: [
            {
                path: '',
                name: 'listings.messages.send.create',
                component: require('../views/listings/messages/send/create').default
            }
        ]
    }
]
